document.addEventListener('DOMContentLoaded', () => {
  const DESKTOP_MIN = 990;

  document.querySelectorAll('.multicolumn').forEach((sec) => {
    const list = sec.querySelector('.multicolumn-list');
    if (!list) return;

    // Create nav UI if not present
    let nav = sec.querySelector('.je-mc-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'je-mc-nav';
      nav.innerHTML = `
        <button type="button" class="je-mc-btn je-mc-prev" aria-label="Previous">‹</button>
        <span class="je-mc-count"><span class="je-mc-cur">1</span>/<span class="je-mc-tot">1</span></span>
        <button type="button" class="je-mc-btn je-mc-next" aria-label="Next">›</button>
      `;
      sec.appendChild(nav);
    }

    const items = Array.from(list.querySelectorAll('.multicolumn-list__item'));
    const prev = nav.querySelector('.je-mc-prev');
    const next = nav.querySelector('.je-mc-next');
    const curEl = nav.querySelector('.je-mc-cur');
    const totEl = nav.querySelector('.je-mc-tot');

    totEl.textContent = String(items.length);

    const getStep = () => {
      if (!items[0]) return 0;
      const gap = parseFloat(getComputedStyle(list).gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    };

    const update = () => {
      if (window.innerWidth < DESKTOP_MIN) {
        nav.style.display = ''; // let mobile theme handle if needed
        return;
      }
      const step = getStep();
      if (!step) return;
      const index = Math.round(list.scrollLeft / step) + 1;
      curEl.textContent = String(Math.min(Math.max(index, 1), items.length));
      nav.style.display = 'flex';
    };

    const go = (dir) => {
      const step = getStep();
      if (!step) return;
      list.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));

    list.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);

    update();
  });
});
